<template>
  <div class="page-container users-container">
    <todo-side-bar selected="visibility" />

    <h1>{{ $t('pages.visibility') }}</h1>

    <el-tabs v-model="activeCreateTab">
      <el-tab-pane label="Professional Visibility" name="professional-visibilty" style="height: 100%">
        <todo-professional-visibility />
      </el-tab-pane>
      <el-tab-pane label="Professional Rating" name="add-professional-rating" style="height: 100%">
        <todo-add-professional-rating :resetTab='resetTab' />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import TodoProfessionalVisibility from './components/ProfessionalVisibility.vue'
  import ProfessionalRating from './components/ProfessionalRating.vue'
  import Vue from 'vue'
  export default {
    components: {
      'todo-professional-visibility': TodoProfessionalVisibility,
      'todo-add-professional-rating': ProfessionalRating
    },

    data() {
      return {
        activeCreateTab: 'create-coupon',
        passdata: {},
        bus: new Vue(),
        data: [],
        resetTab: ''
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import '../../assets/variables';

  .el-input{
    width:auto!important;
  }
  .el-form-item__label{
    line-height: initial!important;
  }
</style>
